'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _reactRouterRedux = require('react-router-redux');

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

var _uriJs = require('uri-js');

var URI = _interopRequireWildcard(_uriJs);

var _FacebookLoginWithButton = require('./FacebookLogin/FacebookLoginWithButton');

var _FacebookLoginWithButton2 = _interopRequireDefault(_FacebookLoginWithButton);

var _DefaultString = require('../../helpers/DefaultString');

var _Error = require('../../helpers/Error');

var _ClientError = require('../../helpers/ClientError');

var _PopupType = require('../../helpers/PopupType');

var _Product = require('../../helpers/Product');

var _Router = require('../../helpers/Router');

var _Language = require('../../helpers/Language');

var _Logs = require('../../helpers/Logs');

var _Logs2 = _interopRequireDefault(_Logs);

var _auth = require('../../redux/modules/auth');

var _popup = require('../../redux/modules/popup');

var _log = require('../../redux/modules/log');

var _FacebookLoginButton = require('./FacebookLoginButton.scss');

var _FacebookLoginButton2 = _interopRequireDefault(_FacebookLoginButton);

var _facebook = require('../../../res/images/icon/facebook.svg');

var _facebook2 = _interopRequireDefault(_facebook);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FacebookLoginButton = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    appInfo: state.appInfo,
    auth: state.auth,
    countryCode: state.auth.countryCode,
    initLang: state.auth.initLang,
    lang: state.auth.lang,
    log: state.log
  };
}, {
  changePopupType: _popup.changePopupType,
  facebookLogin: _auth.facebookLogin,
  facebookUpgrade: _auth.facebookUpgrade,
  login: _auth.login,
  logConnectionMethod: _log.logConnectionMethod,
  pushState: _reactRouterRedux.push
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(FacebookLoginButton, _Component);

  function FacebookLoginButton() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FacebookLoginButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FacebookLoginButton.__proto__ || (0, _getPrototypeOf2.default)(FacebookLoginButton)).call.apply(_ref, [this].concat(args))), _this), _this.onFacebookClick = function () {
      _this.props.logConnectionMethod(_Logs.LogName.ConnectWithFacebook);
      (0, _Logs2.default)(_this.props.log.src, _Logs.LogName.ConnectWithFacebook, _this.props.log, _this.props.auth, _this.props.appInfo);
    }, _this.onCustomFacebookButtonClick = function () {
      var LOGIN_SCHEME = 'login';
      var FB_PATH = 'fb';
      var facebookLoginUrl = window.location.protocol + '//' + window.location.host + (0, _Router.getPathForEmailLink)(_Router.RouterConst.TokenAuthorize + '/' + _Router.RouterConst.Facebook, _this.props.lang);
      var message = {
        appId: _this.props.appInfo.fbAppId[(0, _Product.getThemedProduct)(_this.props.auth.productName, _this.props.auth.clientId)],
        returnUrl: facebookLoginUrl
      };

      window.location = URI.serialize({ scheme: LOGIN_SCHEME, host: FB_PATH, query: _queryString2.default.stringify(message) });
    }, _this.getFacebookText = function () {
      var formatMessage = _this.props.intl.formatMessage;

      var fbString = _DefaultString.translations.Facebook;
      return formatMessage(fbString);
    }, _this.hasCustomClick = function () {
      return [_Product.PLATFORM_NAMES.Ipad, _Product.PLATFORM_NAMES.Iphone, _Product.PLATFORM_NAMES.Android, _Product.PLATFORM_NAMES.AndroidTablet].includes(_this.props.auth.platform);
    }, _this.responseFacebook = function (response) {
      // When user click cancel (response.status === 'not_authorized') or the close button of the facebook popup ('unknown')
      // we don't handle it.
      if (response.accessToken) {
        if (!response.email) {
          _this.props.changePopupType(_PopupType.PopupId.NoEmailOnFacebookAccount);
        } else {
          var lang = _this.props.lang;

          var setPasswordUri = window.location.protocol + '//' + window.location.host + (0, _Router.getPathForEmailLink)(_Router.RouterConst.CreatePasswordAndLinkToProfile, lang);
          if (_this.props.auth.sessionId) {
            _this.props.facebookUpgrade(response.accessToken, lang, setPasswordUri, _this.props.auth.sessionId);
          } else {
            _this.props.facebookLogin(response.accessToken, lang, setPasswordUri);
          }
        }
      }
    }, _this.excludeFacebookButton = function () {
      var excludeFacebookApp = _this.props.appInfo.excludeFacebookApp;
      var regex = new RegExp(excludeFacebookApp.join('|'), 'i');
      return excludeFacebookApp.length > 0 && _this.props.appInfo.excludeFacebook && regex.test(_this.props.auth.productName);
    }, _this.getIcon = function () {
      return _facebook2.default;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(FacebookLoginButton, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.auth.fbLoggingIn && !nextProps.auth.fbLoggingIn) {
        if (nextProps.auth.error) {
          var response = nextProps.auth.error.response;
          if (response) {
            if (response.body.code === _Error.ErrorConst.InvalidValue && response.body.field === _Error.ErrorFieldConst.AccessToken) {
              this.props.changePopupType(_PopupType.PopupId.NoFacebookAccountLinked);
            } else if (response.body.code !== _Error.ErrorConst.InvalidCaptcha) {
              this.props.changePopupType(_PopupType.PopupId.FacebookInvalidRequest);
            }
          } else {
            (0, _ClientError.logClientErrorWithLoggingService)(nextProps.auth.error, new Error().stack, 'universal-loginError', this.props.auth);
            this.props.pushState((0, _Router.getErrorRetryPath)());
          }
        }
      } else if (this.props.auth.lang !== nextProps.auth.lang) {
        // Need to refresh the page because of the facebook login button
        (0, _Language.updateLanguageByReload)(nextProps.auth.lang);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var fbAppId = this.props.appInfo.fbAppId;

      var product = (0, _Product.getThemedProduct)(this.props.auth.productName, this.props.auth.clientId);
      var isButtonCenter = (0, _Product.isIconButtonCenter)(product);
      var lang = (0, _Language.getFacebookLanguage)(this.props.lang, this.props.countryCode);
      var fbIcon = this.getIcon();

      if (this.excludeFacebookButton()) return null;

      return _react2.default.createElement(_FacebookLoginWithButton2.default, {
        appId: fbAppId[product],
        autoLoad: false,
        cssClass: _FacebookLoginButton2.default.facebookButton + (isButtonCenter ? ' ' + _FacebookLoginButton2.default.center : ''),
        fields: 'name,email,picture',
        scope: 'public_profile,email',
        icon: _react2.default.createElement(
          'div',
          { className: 'social-icon-container' },
          _react2.default.createElement('img', { src: fbIcon })
        ),
        language: lang,
        callback: this.responseFacebook,
        onClick: this.onFacebookClick,
        textButton: this.getFacebookText(),
        onCustomFacebookButtonClick: this.hasCustomClick() ? this.onCustomFacebookButtonClick : null
      });
    }
  }]);
  return FacebookLoginButton;
}(_react.Component), _class2.propTypes = {
  appInfo: _react.PropTypes.object,
  auth: _react.PropTypes.object,
  changePopupType: _react.PropTypes.func,
  countryCode: _react.PropTypes.string,
  facebookLogin: _react.PropTypes.func.isRequired,
  facebookUpgrade: _react.PropTypes.func.isRequired,
  intl: _reactIntl.intlShape.isRequired,
  initLang: _react.PropTypes.string,
  lang: _react.PropTypes.string,
  log: _react.PropTypes.object,
  logConnectionMethod: _react.PropTypes.func.isRequired,
  pushState: _react.PropTypes.func.isRequired
}, _temp2)) || _class);
exports.default = (0, _reactIntl.injectIntl)(FacebookLoginButton);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FacebookLoginButton/FacebookLoginButton.js
// module id = 1954
// module chunks = 0